import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { GcpCloudSqlAccesses } from "./accesses.ts";
import { GcpCloudSqlComponents } from "./components.ts";

const GcpCloudSqlFilters = {} as const satisfies AnyFilterSchema;
export type GcpCloudSqlFilters = typeof GcpCloudSqlFilters;

export const GcpCloudSqlRegistration = Registration({
  accesses: GcpCloudSqlAccesses,
  category: "resource",
  components: GcpCloudSqlComponents,
  docs: { install: "postgresql/installing-a-cloudsql-database" },
  filters: GcpCloudSqlFilters,
  itemKind: "VPC",
  label: "GCP CloudSQL",
  logoUrl:
    "https://www.gstatic.com/bricks/image/85b9a54c-5ffc-4126-8824-32fb08fcf1a3.png",
  maturity: "preview",
  requestType: "bridge",
  useMapping: [{ use: "iam_write", component: "iam-write" }],
});

registerIntegration("gcp-cloudsql", GcpCloudSqlRegistration);
